import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, defineAsyncComponent, isVue3, watch } from 'vue-demi';


export default /*#__PURE__*/_defineComponent({
  __name: 'AbMultiselect',
  props: {
  value: {
    type: [String, Array],
    default: null,
  },
  options: {
    type: Array,
    default: () => [],
  },
  placeholder: {
    type: String,
    default: '',
  },
  multiple: {
    type: Boolean,
    default: false,
  },
  searchable: {
    type: Boolean,
    default: true,
  },
  valueProp: {
    type: String,
    default: 'value',
  },
  label: {
    type: String,
    default: 'label',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  inputLabel: {
    type: String,
    default: '',
  },
  error: {
    type: Boolean,
    default: false,
  },
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;

const Multiselect = defineAsyncComponent(() =>
  isVue3
    ? import('@vueform/multiselect')
    : import('@vueform/multiselect/dist/multiselect.vue2.js'),
);




const isOpened = ref(false);

const valueLocal = computed({
  get() {
    return props.value;
  },
  set(value) {
    emit('input', value);
  },
});

const mode = computed(() => {
  if (props.multiple) {
    return 'tags';
  }
  return 'single';
});

const checkIsEmptyValueLocal = (val: string | string[]) => {
  const isArray = Array.isArray(val);
  const isEmpty = isArray ? !val.length : !val;
  return isEmpty;
};

const isLabelLifted = computed(() => {
  const isFullfilled = !checkIsEmptyValueLocal(
    valueLocal.value as string | string[],
  );

  return isFullfilled || isOpened.value;
});

const localSearchValue = ref('');

const onSearchChange = (val: string) => {
  localSearchValue.value = val;
};

const shouldShowPlaceholder = computed(() => {
  const isEmpty =
    checkIsEmptyValueLocal(valueLocal.value as string | string[]) &&
    !localSearchValue.value;

  return isEmpty && isLabelLifted.value;
});

const onOpen = () => {
  isOpened.value = true;
};

const onClose = () => {
  isOpened.value = false;
};

return { __sfc: true,Multiselect, props, emit, isOpened, valueLocal, mode, checkIsEmptyValueLocal, isLabelLifted, localSearchValue, onSearchChange, shouldShowPlaceholder, onOpen, onClose }
}

})